import { System } from "@models/System";
// eslint-disable-next-line object-curly-newline
import { getFirestore, getDocs, collection, query, where, doc, getDoc } from "firebase/firestore";

class SystemDataService {
  collectionName = "system";

  async getActive(): Promise<System | null> {
    const db = getFirestore();
    const systemQuery = query(
      collection(db, this.collectionName),
      where("active", "==", true)
    );
    const data = await getDocs(systemQuery);
    const results: System[] = [];

    data.forEach((item) => {
      results.push({ ...item.data() } as System);
    });
    return results.length > 0 ? results[0] : null;
  }

  async getEventTypes(): Promise<string[]> {
    const db = getFirestore();
    const docRef = doc(db, this.collectionName, "eventTypes");
    const docSnap = await getDoc(docRef);

    if (docSnap.exists()) {
      const data = docSnap.data();
      if (data && data.values) {
        return data.values;
      }
    }

    // Return empty object if no data found
    return [];
  }
}

export default new SystemDataService();
